module.exports = __webpack_public_path__ + "img/bx-manage-choosing-active.d544a258.svg";